import {map} from '../map/map';
import Overlay from 'ol/Overlay';

var overlay = null;

export default function(){

	if(overlay !== null) {

		return overlay;
	} else {
		var popupID = document.getElementById('popup');
		if(popupID !== null) {
			overlay = new Overlay({
			  element: document.getElementById('popup'),
			  autoPan: true
			});

			map.addOverlay(overlay);
		}
		return null;
	}

	return overlay;
}



// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/popup/overlay.js